// @flow
import React from 'react';
import Input from 'antd/lib/input';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem,
  RangePicker
} from '../../../../components';
import type { FilterChildrenParams } from './../../../../components/hoc/Filter';
import Field from '../../../../components/card/Field';
import { SectionContent } from '../../../../components/hoc/common/components/elements';
import type { ExpenseDirectionType } from '../../../../lib/types';
import Selects from '../../../../components/selects';
import moment from 'moment';
import { formatDateTimeToISOString } from '../../../../lib/helpers';

const { ExpenseDirectionTypeSelect } = Selects;

export type ExpenseDirectionFilterParams = {
  search?: string,
  cognosId?: string,
  'budgetLineItem.mnemocode'?: string,
  'budgetLineItem.name'?: string,
  startDate?: string | Date,
  endDate?: string | Date,
  type?: ExpenseDirectionType
};

type Props = {
  filter: ExpenseDirectionFilterParams,
  cleanFilter: Function,
  applyFilter: Function
};

export const StockPartFilter = ({
  filter,
  cleanFilter,
  applyFilter
}: Props) => (
  <SectionContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
        additionalFilter={true}
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter,
          showAdditional,
          handleAdditional
        }: FilterChildrenParams<ExpenseDirectionFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  placeholder="Название"
                  size="small"
                  onChange={e =>
                    changeValue('search', e.target.value || undefined)
                  }
                  value={values.search}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  placeholder="Идентификатор статьи бюдж. формы"
                  size="small"
                  onChange={e =>
                    changeValue(
                      'budgetLineItem.mnemocode',
                      e.target.value || undefined
                    )
                  }
                  value={values['budgetLineItem.mnemocode']}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  placeholder="Наименование статьи бюдж. формы"
                  size="small"
                  onChange={e =>
                    changeValue(
                      'budgetLineItem.name',
                      e.target.value || undefined
                    )
                  }
                  value={values['budgetLineItem.name']}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <ExpenseDirectionTypeSelect
                  value={values.type}
                  onChange={value => changeValue('type', value)}
                  size="small"
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <Input
                  placeholder="Мнемокод направления"
                  size="small"
                  onChange={e =>
                    changeValue('cognosId', e.target.value || undefined)
                  }
                  value={values.cognosId}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
                  size="small"
                  format="DD.MM.YYYY"
                  placeholder={['Начало', 'Конец']}
                  value={[
                    values.startDate ? moment.utc(values.startDate) : null,
                    values.endDate ? moment.utc(values.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    changeValue(
                      'startDate',
                      startDate
                        ? formatDateTimeToISOString(startDate, startDateString)
                        : undefined
                    );
                    changeValue(
                      'endDate',
                      endDate
                        ? formatDateTimeToISOString(endDate, endDateString)
                        : undefined
                    );
                  }}
                />
              </Field>
            </FilterItem>
            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
              handleAdditional={handleAdditional}
              showAdditional={showAdditional}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SectionContent>
);

export default StockPartFilter;
